import { requests } from ".";
import { SERVICE_NAME } from "@/config/serviceNames";

export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
}

const MarketplaceService = {
  getMarketplaceAppRatings: (query?: any) =>
    requests(SERVICE_NAME.MARKETPLACE_API).get("app/review/support", {
      params: query,
    }),

  processReviewComment: (id: string, data?: any) =>
    requests(SERVICE_NAME.MARKETPLACE_API).post(
      `app/review/support/${id}`,
      data
    ),

  async getApps(params: {
    sortByInstallations?: 'true' | 'false'
    sortOrder?: SortOrder
  }) {
    const queryParams = new URLSearchParams()
    
    if (params.sortByInstallations) {
      queryParams.append('sortByInstallations', params.sortByInstallations)
    }
    if (params.sortOrder) {
      queryParams.append('sortOrder', params.sortOrder)
    }

    const url = `/api/marketplace/apps?${queryParams.toString()}`
    return await requests(SERVICE_NAME.MARKETPLACE_API).get(url)
  }
};

export default MarketplaceService;
